export enum PlanSponsorshipType {
  FamiliesForEnterprise = 0,
}
